import React, { useState } from "react";
import './style.scss';

export const CustomSwitch: React.FC<{
  onClick?: Function;
  defaultChecked?: boolean;
}> = ({ onClick, defaultChecked }) => {
  return (
    <label className="switch">
      <input
        type="checkbox"
        className="checkbox"
        defaultChecked={defaultChecked ? defaultChecked : false}
        onChange={() => {
          if (onClick) {
            onClick();
          }
        }}
      />
      <div className="slider"></div>
    </label>
  );
};
